module.exports = __webpack_public_path__ + "img/LogoKISI.cb22c9bb.png";